'use client';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { ReactNode, useCallback, useEffect } from 'react';

import { BackButtonTopNavigation } from '../topNavigation';

export const IframeModal = NiceModal.create(({ iframeId, url, closeEvent, headerTitle, loadEvent }: IframeModalProps) => {
  const modal = useModal();

  const closeIframe = useCallback(
    (event: MessageEvent) => {
      closeEvent(event);
    },
    [closeEvent]
  );

  useEffect(() => {
    (document.querySelector('html') as HTMLElement).style.overflowY = modal.visible ? 'hidden' : 'auto';
    window.addEventListener('message', closeIframe);
    return () => {
      window.removeEventListener('message', closeIframe);
      (document.querySelector('html') as HTMLElement).style.overflowY = 'auto';
    };
  }, [closeIframe, modal.visible]);

  return (
    <>
      {modal.visible && (
        <div className={'fixed bottom-0 left-0 top-0 z-[200] w-screen'}>
          <BackButtonTopNavigation className={'min-w-80'} bg bgColor={'neutral-background-main'} onBackClick={modal.hide} title={headerTitle} />
          <iframe id={iframeId} name={iframeId} src={url} className={'pt-[52px] h-full w-full bg-white'} onLoad={loadEvent} />
        </div>
      )}
    </>
  );
});

type IframeModalProps = {
  iframeId?: string;
  headerTitle?: ReactNode;
  url: string;
  closeEvent: (event: MessageEvent) => void;
  loadEvent?: () => void;
};
